<template>
  <div id="app">
    <!--<MadaRoyaumes />-->
    <MadaTemp />
  </div>
</template>

<script>
//import MadaRoyaumes from "@/layout/MadaRoyaumes";
import MadaTemp from "@/layout/MadaTemp";

export default {
  name: 'App',
  components: {
    MadaTemp,
    //MadaRoyaumes
  },
  onIdle() {
    this.$router.push("/");
  },
  onActive() {
    console.log("active")
  }
}
</script>

<style lang="less">
#app {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

</style>
